export default __webpack_public_path__ + "static/media/pg.cc1bffc7.png";